<template>
  <b-nav-item
    :to="{ path: `/${site.id}-${site.name}` }"
  >
    {{ site.name }}
  </b-nav-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavbarSite',
  data () {
    return {
      sitePosition: parseInt(this.$vnode.key)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredNavEntryByPosition',
      'getStoredSitesByDropdownId'
    ]),
    site () {
      return this.getStoredNavEntryByPosition(this.sitePosition)
    }
  }
}
</script>

<style scoped>
.nav-link {
  white-space: nowrap;
}
</style>
